import { render, staticRenderFns } from "./MenuPreview.vue?vue&type=template&id=aac0dfc8&scoped=true"
import script from "./MenuPreview.vue?vue&type=script&lang=js"
export * from "./MenuPreview.vue?vue&type=script&lang=js"
import style0 from "./MenuPreview.vue?vue&type=style&index=0&id=aac0dfc8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aac0dfc8",
  null
  
)

export default component.exports